import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import device from './modules/device'
import billing from './modules/billing'
import client from './modules/client'
import admin from './modules/admin'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth, device, billing, client, admin
  },
  state: {
    selectedDeviceId: '',
    selectedDevice: null
  },
  mutations: {
    selectDevice (state, payload) {
      state.selectedDeviceId = null
      state.selectedDeviceId = payload
      state.selectedDevice = state.gps.devices[payload]
    }
  },
  actions: {
    openMap: (context, latlng) => {
      var url = `https://maps.google.com/?q=${latlng.Lat},${latlng.Lng}`
      window.open(url)
    }
  }
})
